var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16.857,
    viewBox: "0 0 24 16.857",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#006ebb;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1567.252,475.422a3.429,3.429,0,0,0-4.849,0l-8.346,8.346a4.2,4.2,0,0,0-1.229,2.968v2.111a2.422,2.422,0,0,0,4.135,1.713l6.884-6.884a1.386,1.386,0,0,1,1.961,0l6.885,6.884a2.422,2.422,0,0,0,4.135-1.713v-2.111a4.2,4.2,0,0,0-1.23-2.968Z",
    transform: "translate(-1552.828 -474.418)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.f619848736af2e4d0896f7afa671b91d.svg";
export { ForwardRef as ReactComponent };